export const getAttributesFromString = (str: string) => {
	return str
		.split(' ')
		.filter((a) => !a.startsWith('<'))
		.reduce<Record<string, string>>((obj, a) => {
			a = a.replace(/>$/g, '');
			if (a.includes('=')) {
				return { ...obj, [a.split('=')[0]]: a.split('=')[1].replaceAll('"', '') };
			} else {
				return { ...obj, [a]: '' };
			}
		}, {});
};

export const attributesToString = (attributes: Record<string, string>) => {
	return Object.keys(attributes)
		.map((key) => {
			const value = attributes[key];
			if (value === '' || value === 'undefined') {
				return key;
			} else {
				return `${key}="${value}"`;
			}
		})
		.join(' ');
};
